(function ($) {
  
  	var idPresente = window.PRESENTE[0].id,
        idVariantPresent = window.PRESENTE[0].variantID;
  
    var body = $('body'),
        doc = $(document),
        html = $('html'),
        win = $(window),
        dropdownCart,
        miniProductList;
  
    var sidebarCart = $('#sidebar-cart'),
        checkPresente = sidebarCart.find('#check-presente'),
        btnRemove = sidebarCart.find('.btn-remove'),
        sidebarCartNoItems = sidebarCart.find('.cart-empty'),
        sidebarCartHasItems = sidebarCart.find('.mini-products-list');

    doc.ready(function () {
      dropdownCart = $('#dropdown-cart'),
      miniProductList = dropdownCart.find('.mini-products-list');

      $('#check-presente').on("click", function() {
        alf.presenteEmbrulho();
      });


      // $('#stories-slider').slick({
      //   dots: false,
      //   arrows: false,
      //   infinite: true,
      //   slidesToShow: 1,
      //   centerMode: false,
      //   variableWidth: true,
      //   swipeToSlide: true
      // });

      AOS.init();

    });
  
    $('#cart-item-'+idVariantPresent).on("click", function(event) {
      event.preventDefault();
    });

    var alf = {
        ellaTimeout: null,
        isSidebarAjaxClick: false,
        isAjaxLoading: false,

        updateDropdownCart: function () {
            Shopify.getCart(function (cart) {
                alf.doUpdateDropdownCart(cart);
            });
        },
      
        checkItemsInDropdownCart: function () {
          var cartNoItems = dropdownCart.find('.no-items'),
              cartHasItems = dropdownCart.find('.has-items');



          if (miniProductList.children().length) {
            cartHasItems.show();
            cartNoItems.hide();

            sidebarCartNoItems.hide();
            sidebarCartHasItems.show();
          } else {
            cartHasItems.hide();
            cartNoItems.show();

            sidebarCartNoItems.show();
            sidebarCartHasItems.hide();
          };
        },

        doUpdateDropdownCart: function (cart) {
            //var template = '<li class="item" id="cart-item-{ID}"><a href="{URL}" title="{TITLE}" class="product-image"><img src="{IMAGE}" alt="{TITLE}"></a><div class="product-details"><a href="javascript:void(0)" title="Remove This Item" class="btn-remove remove-item-{removeClass}"><svg aria-hidden="true" data-prefix="fal" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-times fa-w-10 fa-2x"><path fill="currentColor" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z" class=""></path></svg></a><a class="product-name" href="{URL}">{TITLE}</a><div class="option"><small>{VARIANT}</small></div><div class="cart-collateral"><span class="qtt">{QUANTITY} X </span><span class="price">{PRICE}</span></div></div></li>';
            var template = '<li class="item" id="cart-item-{ID}" data-product-id="{ID}"><a href="{URL}" class="product-image"><img src="{IMAGE}" alt="{TITLE}"></a><div class="product-details"><a class="product-name" href="{URL}">{TITLE}</a><div class="option"><small>{VARIANT}</small><a href="JavaScript:void(0);" class="product-details__edit" data-cart-edit aria-label="link" data-url="{URL}&view=cart_edit" data-id="{ID}" data-quantity="{QUANTITY}"><svg xmlns="http://www.w3.org/2000/svg" fill="#000000" viewBox="0 0 48 48" width="144px" height="144px"><path d="M 10.5 6 C 7.468 6 5 8.468 5 11.5 L 5 36 C 5 39.309 7.691 42 11 42 L 22.605469 42 C 22.858469 41.042 23.225516 39.759 23.728516 38 L 11 38 C 9.897 38 9 37.103 9 36 L 9 16 L 39 16 L 39 22.521484 C 39.427 22.340484 39.8615 22.188422 40.3125 22.107422 C 40.7065 22.036422 41.102859 21.992953 41.505859 22.001953 C 42.015859 22.001953 42.515 22.067641 43 22.181641 L 43 11.5 C 43 8.468 40.532 6 37.5 6 L 10.5 6 z M 13.5 20 A 1.50015 1.50015 0 1 0 13.5 23 L 15.5 23 A 1.50015 1.50015 0 1 0 15.5 20 L 13.5 20 z M 21.5 20 C 20.672 20 20 20.671 20 21.5 C 20 22.329 20.672 23 21.5 23 L 34.5 23 C 35.328 23 36 22.329 36 21.5 C 36 20.671 35.328 20 34.5 20 L 21.5 20 z M 41.498047 24 C 41.224047 24.001 40.946969 24.025172 40.667969 24.076172 C 39.783969 24.235172 38.939563 24.696156 38.226562 25.410156 L 26.427734 37.208984 C 26.070734 37.565984 25.807969 38.011141 25.667969 38.494141 L 24.097656 43.974609 C 24.025656 44.164609 23.993 44.365406 24 44.566406 C 24.013 44.929406 24.155594 45.288406 24.433594 45.566406 C 24.710594 45.843406 25.067688 45.986 25.429688 46 C 25.630688 46.007 25.834391 45.975344 26.025391 45.902344 L 31.505859 44.332031 C 31.988859 44.192031 32.431062 43.930266 32.789062 43.572266 L 44.589844 31.773438 C 45.303844 31.060437 45.764828 30.216031 45.923828 29.332031 C 45.973828 29.053031 45.997047 28.775953 45.998047 28.501953 C 46.001047 27.307953 45.540687 26.179312 44.679688 25.320312 C 43.820687 24.460313 42.692047 23.998 41.498047 24 z M 13.5 26 A 1.50015 1.50015 0 1 0 13.5 29 L 15.5 29 A 1.50015 1.50015 0 1 0 15.5 26 L 13.5 26 z M 21.5 26 C 20.672 26 20 26.671 20 27.5 C 20 28.329 20.672 29 21.5 29 L 31.808594 29 L 34.779297 26.027344 C 34.688297 26.010344 34.596 26 34.5 26 L 21.5 26 z M 13.5 32 A 1.50015 1.50015 0 1 0 13.5 35 L 15.5 35 A 1.50015 1.50015 0 1 0 15.5 32 L 13.5 32 z M 21.5 32 C 20.672 32 20 32.671 20 33.5 C 20 34.329 20.672 35 21.5 35 L 25.808594 35 L 28.808594 32 L 21.5 32 z"/></svg></a></div><div class="cart-collateral"><span class="price">{PRICE}</span></div><div class="quantity"><input class="item-quantity" name="quantity" id="updates_{ID}" data-qtt-id1="quantity_{ID}" value="{QUANTITY}" type="number" /><span class="error-message-input"></span></div></div><a href="javascript:void(0)" title="Remove This Item" class="btn-remove"><svg aria-hidden="true" data-prefix="fal" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-times fa-w-10 fa-2x"><path fill="currentColor" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z" class=""></path></svg></a></li>';

            $('[data-cart-count]').text(cart.item_count);
            dropdownCart.find('.summary .price').html(Shopify.formatMoney(cart.total_price, window.money_format));
          	$('#sidebar-cart').find('.cart-footer .notranslate').html(Shopify.formatMoney(cart.total_price, window.money_format));

            miniProductList.html('');

            if (cart.item_count > 0) {
                for (var i = 0; i < cart.items.length; i++) {
                    var item = template;
                  
                  console.log(cart.items[i]);
                  
                    item = item.replace(/\{ID\}/g, cart.items[i].id);
                    item = item.replace(/\{URL\}/g, cart.items[i].url);
                    item = item.replace(/\{TITLE\}/g, alf.translateText(cart.items[i].product_title));
                    item = item.replace(/\{VARIANT\}/g, cart.items[i].variant_title || '');
                    item = item.replace(/\{QUANTITY\}/g, cart.items[i].quantity);
                    item = item.replace(/\{removeClass\}/g, cart.items[i].id);
                    item = item.replace(/\{IMAGE\}/g, Shopify.resizeImage(cart.items[i].image, '160x'));
                    if (cart.items[i].price != cart.items[i].final_price) {
                        item = item.replace(/\{PRICE\}/g, '<oldprice>'+Shopify.formatMoney(cart.items[i].price, window.money_format)+'</oldPrice> <discounted>'+Shopify.formatMoney(cart.items[i].final_price, window.money_format)+'</discounted>');
                    }else{
						item = item.replace(/\{PRICE\}/g, Shopify.formatMoney(cart.items[i].price, window.money_format));
                    }

                    miniProductList.append(item);
                }

                alf.removeItemDropdownCart(cart);

            }

            alf.checkItemsInDropdownCart();
        },
      
        translateText: function (str) {
          if (!window.multi_lang || str.indexOf("|") < 0)
            return str;

          if (window.multi_lang) {
            var textArr = str.split("|");

            if (translator.isLang2())
              return textArr[1];
            return textArr[0];
          };
        },

        removeItemDropdownCart: function (cart) {
            var btnRemove = dropdownCart.find('.btn-remove');

            btnRemove.off('click.removeCartItem').on('click.removeCartItem', function (e) {
                e.preventDefault();
                e.stopPropagation();

                var productId = $(this).parents('.item').attr('id');
                productId = productId.match(/\d+/g);

                Shopify.removeItem(productId, function (cart) {
                    $("#cart-item-"+productId).remove();
                    $("#sidebar-cart-item-"+productId).remove();
                    alf.doUpdateDropdownCart(cart);
                });
            });
        },
      
        presenteEmbrulho: function(){
          
            var checked = $("input#check-presente:checked").length;

            if (checked == 0) {

              let updateData = {
                updates: {
                  40682829250744: 0
                }
              };
              //let updateData = "{"+window.PRESENTE[0].queryDelete+"}";

              fetch('/cart/update.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify(updateData)
              })
              .then(response => {
                Shopify.getCart(function (cart) {
                  alf.doUpdateDropdownCart(cart);
                });
                console.log("Teste", response.json());
              })
              .catch(function (error) {
                console.error('Request failed', error)
              });

              
            }else{

              let formData = {
                'items': [
                  { 
                    'id': 40682829250744, 
                    'quantity': 1 
                  }
                ] 
              };
              
              /*let formData = window.PRESENTE[0].queryAdd;*/

              fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
              })
              .then(response => {
                Shopify.getCart(function (cart) {
                  alf.doUpdateDropdownCart(cart);
                });
                console.log(response.json());
              })
              .catch((error) => {
                console.error('Error:', error);
              });

            }
        }

    };
  
  function requestItens(){
    $.getJSON('/cart.js', function(cart) {
      //const items = cart.items; 
      //checkItens(items);
      console.log(cart);
    });
  }
  
  function checkItens(items){
    $(items).each(function(index) {
      console.log(this);
    });
  }
  
  requestItens();
  
  // Seleciona o elemento do slider
var sliderElement = document.querySelector(".slide-taylors-home");

// Verifica se o slider realmente existe na página
if (sliderElement) {
  
  // 1. Lê os valores do data-attribute que colocamos no HTML
  const autoplayEnabled = sliderElement.dataset.autoplay === 'true';
  const loopEnabled = sliderElement.dataset.loop === 'true';
  const autoplayTime = parseInt(sliderElement.dataset.time) || 5000; // Usa 5000 (5s) como padrão se algo der errado

  // 2. Cria o objeto de configuração do autoplay
  let autoplayConfig = false; // Começa como desligado
  if (autoplayEnabled) {
    autoplayConfig = {
      delay: autoplayTime,
      disableOnInteraction: false
    };
  }

  // 3. Inicializa o Swiper com as configurações dinâmicas
  var tailors = new Swiper(sliderElement, { // Importante: passa o "sliderElement" aqui
      autoplay: autoplayConfig, // <--- CORRIGIDO
      loop: loopEnabled,      // <--- CORRIGIDO
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        // when window width is >= 640px
        640: {
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        }
      }
  });
}
  
  var WeBasic = new Swiper(".slide-we-basic", {
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    autoplay: {
      delay: 5000,
    },
    loop: true
  });
  
  var slideTop = new Swiper(".topBarSlide", {
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    slidesPerView: 2,
    autoplay: {
      delay: 5000,
    },
    loop: true,
    breakpoints: {
      // when window width is >= 640px
      1024: {
        loop: false,
        slidesPerView: 2,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
      }
    }
  });
  
  $('[troca-facil]').click(function(){
    $('.trocaFacilContainer').css('visibility', 'visible');
  });

  $('body').on("click", ".trocaFacilContainer", function(event){
    if(($(event.target).closest('.trocaFacilContent').length === 0)){
      // e.preventDefault();
      $('.trocaFacilContainer').css('visibility', 'hidden');
    }
  });

  $(".trocaFacilContainer").delegate('.trocaFacilContent', 'click', function(e){ 
    e.stopImmediatePropagation(); 
  }).click(function() { 
    alert('test'); 
  });
  
  (function () {
    var announcementBar = document.querySelector('.is_parallax');

    $(document).on('click', '[href^="#"]:not(.icon-search), [data-href]', function (event) {
      var selector = event.target.hasAttribute('href') ? event.target.getAttribute('href') : event.target.getAttribute('data-href');

      if (selector === '#') {
        return;
      }

      var element = document.querySelector(selector),
          offset = parseInt(event.target.getAttribute('data-offset') || 0);

      if (announcementBar) {
        offset -= announcementBar.clientHeight;
      }

      if (event.target.hasAttribute('data-focus-on-click')) {
        var prevScrollY = window.pageYOffset;
        element.focus({ preventScroll: true });

        // hack to fix scroll jump after focus
        if (window.pageYOffset !== prevScrollY) {
          window.scrollTo(window.pageXOffset, prevScrollY);
        }

        element.focus();
      }

      window.scrollTo({ behavior: 'smooth', top: element.offsetTop - offset });

      event.preventDefault();
    });
  })();
  
  $(document).on('click', '[open-cart-mobile]', function(event) {
    $('html').addClass('cart-show');
  });


})(jQuery);

$(document).ready(function() {
    $(document).on('click', '.fake-swatch-element', function(e) {
        e.preventDefault();

        const $target = $(e.currentTarget);
        $target.closest('.selector-wrapper-2').find('.check-swatch').removeClass('check-swatch');
        $target.addClass('check-swatch');
    
        // Seleciona as imagens dentro do produto correspondente
        const $imgElement = $target.closest(".product-item").find('.product-image a > picture img');
        const $imgSecondElement = $target.closest(".product-item").find('.images-two img');
    
        // Obtém as novas URLs das imagens a partir dos atributos `data-featured` e `data-image`
        const newImageUrl = $target.data('featured');
        const secondImageUrl = $target.data('image');
    
        if (newImageUrl) {
            // Adiciona uma classe para indicar que está carregando
            $imgElement.addClass("loading");
            $imgSecondElement.addClass("loading");
    
            // Pré-carrega a primeira imagem
            const tempImg1 = new Image();
            tempImg1.src = newImageUrl;
            tempImg1.onload = function() {
                $imgElement.attr("src", newImageUrl);
                $imgElement.attr("srcset", newImageUrl);
                $imgElement.attr("data-srcset", newImageUrl);
                $imgElement.removeClass("loading"); // Remove o loading quando carregar
            };
    
            // Pré-carrega a segunda imagem (caso exista)
            if (secondImageUrl) {
                const tempImg2 = new Image();
                tempImg2.src = secondImageUrl;
                tempImg2.onload = function() {
                    $imgSecondElement.attr("src", secondImageUrl);
                    $imgSecondElement.attr("srcset", secondImageUrl);
                    $imgSecondElement.attr("data-srcset", secondImageUrl);
                    $imgSecondElement.removeClass("loading");
                };
            }
        }
    })
});